import { render, staticRenderFns } from "./areaSession.vue?vue&type=template&id=32b2aba4&scoped=true"
import script from "./areaSession.vue?vue&type=script&lang=js"
export * from "./areaSession.vue?vue&type=script&lang=js"
import style0 from "./areaSession.vue?vue&type=style&index=0&id=32b2aba4&prod&lang=less&scoped=true"
import style1 from "./areaSession.vue?vue&type=style&index=1&id=32b2aba4&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32b2aba4",
  null
  
)

export default component.exports